import { render, staticRenderFns } from "./ChangelogsApi.vue?vue&type=template&id=7a8f5040&scoped=true&"
import script from "./ChangelogsApi.vue?vue&type=script&lang=js&"
export * from "./ChangelogsApi.vue?vue&type=script&lang=js&"
import style0 from "./ChangelogsApi.vue?vue&type=style&index=0&id=7a8f5040&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8f5040",
  null
  
)

export default component.exports